/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */

import React, { useEffect, useState } from 'react';
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import Divider from '@components/global/Divider';
import ItemDetail from '@components/global/ItemDetail';
import ProductReturnItem from '@components/global/ProductReturnItem';
import SociollaText from '@components/sociolla/SociollaText';
import TableMobile from '@components/table/TableMobile';
import ModalSearch from '@components/modal/ModalSearch';
import Button from '@components/form/Button';
import { ButtonSticky } from '@components/screen/Layout';
import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import { currency } from '@global/helpers';

const dimension = Dimensions.get('screen');
const actionWidth = dimension.width - 30;

const OrderLines = (props) => {
  const detailData =
    props.detailData && Object.keys(props.detailData).length
      ? props.detailData
      : {};
  const isConfirm = detailData.status == 'need_approval';
  const products = props?.products?.length ? props.products : [];
  const skip = props?.skip ? Number(props.skip) : 0;
  const limit = props?.limit ? Number(props.limit) : 0;
  const showLoadMore = skip <= products?.length && products?.length >= limit;

  const [focused, setFocused] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    setKeyword('');
  }, []);

  const onShowProductDetail = (data) => {
    if (focused) {
      onCloseSearch();
    }
  };

  const onLoadMoreProducts = () => {
    try {
      props.onLoadMoreProducts({ keyword: keyword, skip: skip + limit });
    } catch (error) {}
  };

  const onSearch = (val) => {
    setKeyword(val);
    try {
      props.onSearch({ keyword: val, skip: 0 });
    } catch (error) {}
  };

  const onCloseSearch = () => {
    setFocused(false);
    onSearch();
  };

  const ButtonLoadMore = ({ title = 'Load More', width = 150, onPress }) => {
    return showLoadMore ? (
      <View
        style={{
          width: '100%',
          paddingVertical: 15,
          alignItems: 'center',
        }}>
        <Button
          rounded
          buttonStyle={{ width: width }}
          title={
            <SociollaText
              type="bold"
              style={{
                fontSize: 14,
                letterSpacing: 0.5,
                color: Colors.white,
              }}>
              {title}
            </SociollaText>
          }
          onPress={() => onPress()}
        />
      </View>
    ) : (
      false
    );
  };

  return (
    <View style={{ width: '100%' }}>
      {isWeb ? (
        <View style={{ width: '100%', padding: 15 }}>
          <ScrollView contentContainerStyle={{ width: '100%' }}>
            {products?.length ? (
              products.map((item, idx) => (
                <ProductReturnItem
                  data={item}
                  withoutDiscount={true}
                  selectedRules={
                    item?.free_product?.id ? item.free_product : {}
                  }
                  isShowStock={detailData?.status == 'need_approval'}
                  orderStatus={detailData?.status || ''}
                  isDetail
                  onShow={() => onShowProductDetail(item)}
                  key={idx}
                />
              ))
            ) : (
              <View style={{ width: '100%', paddingVertical: 20 }}>
                <SociollaText>No data found</SociollaText>
              </View>
            )}
            <ButtonLoadMore onPress={() => onLoadMoreProducts()} />
          </ScrollView>
        </View>
      ) : (
        <TableMobile
          placeholder="Search products..."
          isSmall={true}
          onSearch={(value) => onSearch(value)}
          onFocus={() => setFocused(true)}
          tableData={products}
          renderItem={({ data, index }) => (
            <ProductReturnItem
              data={data}
              withoutDiscount={true}
              selectedRules={data?.free_product?.id ? data.free_product : {}}
              isShowStock={detailData?.status == 'need_approval'}
              orderStatus={detailData?.status || ''}
              isDetail
              onShow={() => onShowProductDetail(data)}
              key={index}
            />
          )}
          footerComponent={
            showLoadMore ? (
              <ButtonLoadMore
                title="See More"
                width={actionWidth}
                onPress={() => setFocused(true)}
              />
            ) : (
              false
            )
          }
        />
      )}
      <Divider />
      <View
        style={{
          paddingVertical: 10,
          paddingHorizontal: 15,
          flexDirection: 'column',
          ...(isConfirm ? { paddingBottom: !isNative ? 15 : 70 } : {}),
        }}>
        <ItemDetail
          between={true}
          name="Subtotal"
          value={currency(detailData.subtotal, true)}
        />
        <ItemDetail
          between={true}
          name="Taxes"
          value={currency(detailData.total_tax_amount, true)}
        />
        <ItemDetail
          between={true}
          name="TOTAL"
          nameBold={true}
          nameStyle={{ color: Colors.blue0 }}
          value={currency(detailData.total_amount, true)}
          valueBold={true}
          valueStyle={{ color: Colors.blue1 }}
        />
      </View>

      <ModalSearch
        visible={focused}
        onClose={() => onCloseSearch()}
        children={
          <>
            <TableMobile
              placeholder="Search products..."
              autoFocus={true}
              onSearch={(value) => onSearch(value)}
              tableData={products}
              renderItem={({ data, index }) => (
                <ProductReturnItem
                  data={data}
                  onShow={() => onShowProductDetail(data)}
                  key={index}
                />
              )}
              footerComponent={true}
            />
            <ButtonSticky
              show={focused}
              customHost="modal-sticky-button"
              buttons={[
                {
                  component: (
                    <View style={styles.footerStyle}>
                      <TouchableOpacity
                        style={[
                          styles.closeSearch,
                          {
                            width: showLoadMore ? 100 : actionWidth,
                          },
                        ]}
                        activeOpacity={0.6}
                        onPress={() => onCloseSearch()}>
                        <SociollaText type="bold">Close</SociollaText>
                      </TouchableOpacity>
                      {showLoadMore ? (
                        <Button
                          rounded
                          buttonStyle={{
                            width: actionWidth - 110,
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Load More
                            </SociollaText>
                          }
                          onPress={() => onLoadMoreProducts()}
                        />
                      ) : (
                        false
                      )}
                    </View>
                  ),
                },
              ]}
            />
          </>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  footerStyle: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  closeSearch: {
    paddingVertical: 8,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    borderColor: Colors.grey0,
    borderWidth: 1,
  },
});

export default OrderLines;
